import {
  string as yupString,
  number as yupNumber,
} from 'yup';

import InputFormik from '../../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../../shared/forms/select/sdkSelectFormik.component';
import { required } from '../../../shared/forms/validators';
import { countryCodeGetter } from './valueGetters';

const schema = [
  {
    name: 'tagCode',
    component: InputFormik,
    meta: { label: 'Tag Code' },
    options: { disabledWhenEditing: true, yupType: yupNumber(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'tagDescription',
    component: InputFormik,
    meta: { label: 'Tag Description' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'countryCode',
    component: InputFormik,
    meta: { label: 'Country Code', valueGetter: countryCodeGetter },
    options: { yupType: yupString(), readOnly: true },
    additionalProps: { disabled: true },
  },
  {
    name: 'countryTaxType',
    component: SelectFormik,
    meta: { label: 'Country Tax Type', optionsKey: 'countryTaxTypes' },
    options: { disabledWhenEditing: true, yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true, virtualized: true },
  },
];

export default schema;
